<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="80px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="层级" prop="factory">
            <el-select v-model="searchForm.filterData.tag" @change="selectSerachTag" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="对象类型" prop="employeeNo">
            <el-select v-model="searchForm.filterData.optionType" placeholder="请选择">
              <el-option v-for="item in serachTypeList" :key="item.index" :label="item.name" :value="item.index"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="描述">
            <el-input v-model.trim="searchForm.filterData.optionValue" placeholder="描述" />
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="small" @click="searchPage">搜索</el-button>
          <el-button class="orange-btn" size="small" @click="resetForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="showSubmit(false)">新增配置 </el-button>
        <el-button type="primary" size="mini" @click="showSubmit(true)">修改配置 </el-button>
        <el-button type="primary" size="mini" @click="deleteConfig()">删除配置 </el-button>
      </template>
      <el-table
        v-loading="loading"
        @select="serlectRow"
        ref="table"
        :height="maxTableHeight"
        :data="tableData.records"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        style="width: 100%"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column width="65">
          <template slot-scope="scope">
            <el-radio v-model="radio" :label="scope.row.id" @change.native="getCurrentRow(scope.row)">&nbsp; </el-radio>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="tagName" label="层级"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="optionTypeName" label="对象类型"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="sort" label="顺序"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="optionValue" label="描述"></el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="footerBox">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <edit-dialog 
      :visible.sync="dialogFormVisible" 
      v-if="dialogFormVisible" 
      :rowData="editRequestParam" 
      :isEdit="showFlag"
      :searchFormData="searchForm"
      :toStoreBox="toStoreBox"
      @success="onSearch" 
    />
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin';
import editDialog from "./edit.vue";
export default {
  name: "SysConfig",
  mixins: [pagePathMixin, tableMixin],
  components: { editDialog },
  data() {
    return {
      toStoreBox: [],
      options: [
        { value: 1, label: "SPU" },
        { value: 2, label: "SKU" },
        { value: 3, label: "产品" },
        { value: 4, label: "包件" },
      ],
      serachTypeList: [],
      showFlag: false,
      searchForm: {
        filterData: {
          tag: null,
          optionType: "",
        },
      },
      rules: {},
      editRequestParam: {},
      dialogFormVisible: false,
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      model: [],
      radio: null,
      loading: false,
    };
  },
  methods: {
    serlectRow(i, v) {
      this.model = i;
    },
    selectSerachTag(value) {
      this.searchForm.filterData.optionType = "";
      this.getBaseType(value);
    },
    deleteConfig() {
      if (!this.editRequestParam.id) {
        this.$message.error("请先选择一行数据");
        return;
      }
      this.$confirm("确定删除此数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$q.goods.deleteConfig({ params: { id: this.editRequestParam.id } }).then((res) => {
          if (res.success) {
            this.$message.success("删除成功");
            this.onSearch();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    showSubmit(type) {
      this.showFlag = type;
      if (type && !this.editRequestParam.id) {
        this.$message.error("请先选择一行数据");
        return;
      }
      this.dialogFormVisible = true;
    },
    getCurrentRow(row) {
      this.editRequestParam = {
        id: row.id,
        tag: row.tag,
        optionType: row.optionType,
        sort: row.sort,
        optionValue: row.optionValue,
      };
      this.radio = row.id;
    },
    searchPage() {
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    onSearch() {
      this.loading = true;
      this.searchForm.pageNum = this.tableData.pageNum;
      this.searchForm.pageSize = this.tableData.pageSize;
      this.$q.goods.listPage({ data: JSON.stringify(this.searchForm) }).then((res) => {
        this.tableData = res.data;
        this.loading = false;
      });
    },
    getBaseType(value) {
      this.$q.goods.getBaseType({ params: { tagType: value } }).then((res) => {
        this.serachTypeList = res.data;
      });
    },
    resetForm() {
      this.searchForm = {
        filterData: {
          tag: null,
          optionType: "",
          optionValue: "",
        },
      };
      this.serachTypeList = [];
      this.onSearch();
    },
    onSizeChange(pageSize) {
      this.tableData.pageSize = pageSize;
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    onCurrentChange(pageNum) {
      this.tableData.pageNum = pageNum;
      this.onSearch();
    },
    get_shopOptions() {
      this.$q.product.storeSelect().then((res) => {
        this.toStoreBox = res.data;
      });
    },
  },
  mounted() {
    this.onSearch();
    this.get_shopOptions();
  },
};
</script>

<style lang="stylus" scoped>
.footerBox
  text-align right
</style>
